import { connect } from 'react-redux';
import DisplayActions from '../../../../redux/DisplayRedux';
import LibraryActions from '../../adLibrary/redux/AdLibraryRedux';
import LibraryStepComponent from '../components/step1_library';

const mapStateToProps = ({ display, userAccount, library }) => ({
  uploadingAds: library.uploading,
  user: userAccount.user,
  isSuperUser: userAccount.isSuperUser,
  token: userAccount.token,
  cart: display.cart,
  brand: display.brand,
  listOfContentsInCampaign: display.listOfContentsInCampaign,
  listResolutionWithContent: display.listResolutionWithContent,
  listResolutionWithPlaceholders: display.listResolutionWithPlaceholders,
  customContents: display.customContents,
  toleranceResolution: display.toleranceResolution,
  toleranceResolutionInit: display.toleranceResolutionInit,
  editCampaignActive: display.editCampaignActive,
  currentCampaign: display.currentCampaign,
  creationType: display.creationType,
  placeholders: display.placeholders,
  fetchingPlaceholders: display.fetchingPlaceholders,
  listOfPlaceholdersInCampaign: display.listOfPlaceholdersInCampaign,
  isPaymentStatusApproved: !!(display.currentCampaign && display.currentCampaign.payment_status === 'approved'),
  initialBackup: display.initialBackup,
  hasInitialBackup: display.hasInitialBackup,
  reportSingleData: display.reportSingleData,
  libraryContents: display.libraryContents,
  loadingContentsbyCompany: display.loadingContentsbyCompany,
  defaultContent: display.defaultContent,
  fileCanvaNew: display.fileNew,
  statusNewContent: display.statusNewContent,
  categories: display.categories,
  loadingCategories: display.loadingCategories,
});

const mapDispatchToProps = (dispatch) => ({
  setListOfContentsInCampaign: (contents) => dispatch(DisplayActions.setListOfContentsInCampaign(contents)),
  setListResolutionWithContent: (listResolutionWithContent) =>
    dispatch(DisplayActions.setListResolutionWithContent(listResolutionWithContent)),
  updateCustomContents: (customContents) => dispatch(DisplayActions.updateCustomContents(customContents)),
  updateListOfContentsInCampaign: (content) => dispatch(DisplayActions.updateListOfContentsInCampaign(content)),
  remplaceContentForUniqueVersion: (contentId, listDisplay, contentToReplace) =>
    dispatch(DisplayActions.remplaceContentForUniqueVersion(contentId, listDisplay, contentToReplace)),
  remplaceContentFromCampaign: (contentId, contentToReplace) =>
    dispatch(DisplayActions.remplaceContentFromCampaign(contentId, contentToReplace)),
  deleteContentFromCampaign: (contentId, contentVersionName) =>
    dispatch(DisplayActions.deleteContentFromCampaign(contentId, contentVersionName)),
  setToleranceResolution: (toleranceResolution) => dispatch(DisplayActions.setToleranceResolution(toleranceResolution)),
  setInitialBackup: (initialBackup) => dispatch(DisplayActions.setInitialBackup(initialBackup)),
  restoreCampaignToOriginalState: () => dispatch(DisplayActions.restoreCampaignToOriginalState()),
  clearCustomContents: () => dispatch(DisplayActions.clearCustomContents()),
  cleanListOfContentsInCampaign: () => dispatch(DisplayActions.cleanListOfContentsInCampaign()),
  setListOfPlaceholdersInCampaign: (placeholders) => dispatch(DisplayActions.setListOfPlaceholdersInCampaign(placeholders)),
  setListResolutionWithPlaceholders: (listResolutionWithPlaceholders) =>
    dispatch(DisplayActions.setListResolutionWithPlaceholders(listResolutionWithPlaceholders)),
  getPlaceholders: (listResolution) => dispatch(DisplayActions.getPlaceholdersRequest(listResolution)),

  getContentsByCompany: (companyId, params) => dispatch(DisplayActions.getContentsByCompanyRequest(companyId, params)),
  getContentsByUsers: (userId, params) => dispatch(DisplayActions.getContentsByUsersRequest(userId, params)),
  setLibraryContents: (contents) => dispatch(DisplayActions.setLibraryContents(contents)),
  updateDefaultContentRequest: (id) => dispatch(DisplayActions.updateDefaultContentRequest(id)),
  setStatusNewContent: (statusNewContent) => dispatch(DisplayActions.setStatusNewContent(statusNewContent)),
  updateRelationCampaignRequest: (content, relation, campaignId) =>
    dispatch(DisplayActions.updateRelationCampaignRequest(content, relation, campaignId)),
  updateContentDisplayByContent: (content, displayId) =>
    dispatch(DisplayActions.updateContentDisplayByContent(content, displayId)),

  uploadAds: (files, meta) => dispatch(LibraryActions.uploadAdsRequest(files, meta)),
  getCategories: () => dispatch(DisplayActions.getCategoriesRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LibraryStepComponent);
